import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, ContactSection, IntroSection, WhyChooseUs } from "@/components/features/about";
import AnimatedSection from "../../components/common/animations/AnimatedSection/AnimatedSection";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";
import { OtherValues } from "@/components/features/careers";

export default function ItServicePackage() {
    return (
        <>
            <SEO
                title="Who we are - SAN micron"
                description="Join us at SAN micron as we work together to explore new possibilities. We look forward to helping your business grow, innovate, and succeed in an ever-evolving digital landscape."
            />
            <div>
                <AnimatedSection><Breadcrumbs /></AnimatedSection>
                <AnimatedSection><WhyChooseUs /></AnimatedSection>
                <AnimatedSection><OtherValues /></AnimatedSection>
                <AnimatedSection>
                    <CallToAction title="Join SAN micron to grow, innovate, and succeed in the digital world." />
                </AnimatedSection>
                <AnimatedSection><IntroSection /></AnimatedSection>
                <AnimatedSection><ContactSection /></AnimatedSection>
                <Footer />
            </div>
        </>
    );
}